<template>
  <div class="login_wrapper bg-green">
    <div>
      <div class="card login-form">
        <div class="card-body">
          <div class="login-form-area">
            <div class="card-title text-center">
              <img class="img-fluid" width="75" src="@/assets/images/login/logo.png" alt="">
              <!-- <h6 style="margin: 10px auto 0;color: #fff;">{{ $t('globalTrans.loginTitle') }}</h6> -->
            </div>
            <b-alert :show="errorAlert" variant=" " dismissible fade class="text-white bg-danger">
              <div class="iq-alert-icon">
                <i class="ri-information-line"></i>
              </div>
              <div class="iq-alert-text">{{ errorMsg }}</div>
            </b-alert>
            <div class="card-text">
              <div class="loader" v-show="loading">
                <img src="@/assets/images/login/loader.gif" alt="">
              </div>
              <ValidationObserver ref="form" v-slot="{ handleSubmit, reset }">
                <b-form @submit.prevent="handleSubmit(login)" @reset.prevent="reset" autocomplete="off">
                  <ValidationProvider name="Username/Email" vid="email" rules="required">
                    <b-input-group label-for="email" slot-scope="{ valid, errors }">
                      <b-input-group-prepend>
                        <span class="input-group-text"><i class="fa fa-user fa-lg"></i></span>
                      </b-input-group-prepend>
                      <b-form-input id="email" v-model="user.email" :placeholder="$t('globalTrans.usernameOrEmail')"
                        :state="errors[0] ? false : (valid ? true : null)"></b-form-input>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </b-input-group>
                  </ValidationProvider>
                  <ValidationProvider name="password" rules="required|min:3">
                    <b-input-group label-for="password" slot-scope="{ valid, errors }" class="mt-4 mb-3">
                      <b-input-group-prepend>
                        <span class="input-group-text">
                          <i class="fa fa-lock" aria-hidden="true"></i>
                        </span>
                      </b-input-group-prepend>
                      <b-form-input
                        id="password"
                        :type="showPassword ? 'text' : 'password'"
                        v-model="user.password"
                        :placeholder="$t('globalTrans.password')" autocomplete="off"
                        :state="errors[0] ? false : (valid ? true : null)"></b-form-input>
                      <a href="javascript:" class="logineye-wrapper" @click="showPassword =! showPassword">
                        <i v-if="showPassword" class="fa fa-eye-slash" aria-hidden="true"></i>
                        <i v-else class="fa fa-eye" aria-hidden="true"></i>
                      </a>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </b-input-group>
                  </ValidationProvider>
                  <div class="custom-control custom-checkbox">
                    <b-col>
                      <input type="checkbox" class="custom-control-input" id="customControlInline" />
                      <label class="custom-control-label" for="customControlInline">{{ $t('globalTrans.remember_me')
                      }}</label>
                    </b-col>
                    <b-col>
                      <router-link :to="{ name: 'authSignUp.forgot_password.otp_sending' }">
                        <i class="mdi mdi-lock mr-1"></i> {{ $t('globalTrans.forgot_your_password') }}
                      </router-link>
                    </b-col>
                  </div>
                  <div class="mt-3">
                    <b-row>
                      <b-col sm="12">
                        <button class="btn btn-success btn-block" type="submit">{{ $t('globalTrans.login') }}</button>
                      </b-col>
                    </b-row>
                  </div>
                  <!-- <div class="mt-3">
                    <b-row>
                      <b-col sm="12">
                        <a class="btn btn-success btn-block" :href="returnUrl">{{ $t('globalTrans.nothi_login') }}</a>
                      </b-col>
                    </b-row>
                  </div> -->
                  <div class="sign-up mt-2">
                    {{ $t('globalTrans.dont_have_an_account') }}
                    <router-link :to="{ name: 'authSignUp.sign_up' }" class="float-right">
                      {{ $t('globalTrans.sign_up_x') }}
                    </router-link>
                  </div>
                </b-form>
              </ValidationObserver>
              <center>
              <br>
              <a class="btn btn-success" @click="resetCache">{{ $t('globalTrans.remove_browser_cache') }}</a>
              </center>
            </div>
          </div>
        </div>
      </div>
      <div class="company-logo">
        <span style="margin-right: 10px;font-size: 0.73rem;">{{ $t('secret_question.design_and_Development')
        }}</span>
        <a href="https://www.syntechbd.com/" target="_blank">
          <img class="img-fluid" width="30" src="@/assets/images/login/syntech-logo-icon.png" alt="" />
          <span style="margin-left: 3px;font-size: 0.73rem;">Syntech Solution Ltd.</span>
        </a>
      </div>
    </div>
    <b-modal id="modal-register">
      <RegistrationModal/>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import RestApi, { authServiceBaseUrl } from '@/config/api_config'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { usernameCheckApi, userDataApi } from '../api/routes'
import RegistrationModal from './RegistrationModal'

export default {
  components: { ValidationObserver, ValidationProvider, RegistrationModal },
  data: () => ({
    loading: false,
    returnUrl: '',
    user: {
      username: '',
      password: '',
      email: '',
      nothi_login: 0
    },
    errorAlert: false,
    errorMsg: '',
    showPassword: false
  }),
  computed: {
    ...mapGetters({
      selectedLang: 'Setting/langState',
      // langsOptions: 'Setting/langOptionState',
      serviceUrl: 'Portal/serviceUrl'
    })
  },
  created () {
    // this.setDefaultLang()
    localStorage.setItem('user_panel_type', 'guest')
    this.returnUrl = process.env.VUE_APP_NOTHI_BASE_URL + '/login?referer=' + btoa(window.location.origin + '/auth/nothi-login-process')
  },
  mounted () {
    localStorage.removeItem('access_token')
    localStorage.removeItem('user')
  },
  methods: {
    resetCache () {
      localStorage.clear()
      location.reload(true)
    },
    setDefaultLang () {
      this.langsOptions.forEach(element => {
        if (element.value === 'en') {
          this.$i18n.locale = element.value
          this.langChangeState(element)
        }
      })
    },
    async login () {
      // if user already logged in
      const isLoginPanel = localStorage.getItem('user_panel_type')
      if (isLoginPanel && isLoginPanel !== 'guest') {
        this.loading = true
        window.location.reload()
        this.loading = false
        return
      }

      try {
        this.loading = true
        this.user.username = this.user.email
        const apiResponse = await RestApi.postData(authServiceBaseUrl, '/v1/oauth/token', this.user)

        if (!apiResponse.access_token) {
          this.errorAlert = true
          this.errorMsg = this.$t('authentication.loginError')
          this.loading = false
          return
        }
        localStorage.setItem('access_token', apiResponse.access_token)
        if (apiResponse.success) {
          this.$store.dispatch('Auth/updateAuthUser', Object.assign(
            {},
            apiResponse.user.data,
            { ssoLogin: false },
            {
              username: apiResponse.user.username,
              user_id: apiResponse.user.user_id,
              user_type: apiResponse.user.user_type,
              is_org_admin: apiResponse.user.is_org_admin,
              office_detail: apiResponse.user.office_detail,
              last_panel: apiResponse.user.last_panel,
              panels: apiResponse.user.panels,
              userDetail: apiResponse.user.userDetail,
              dashboard_user: apiResponse.user.dashboard_user
            }
          ))
          localStorage.setItem('accessUsername', apiResponse.user.username)
          localStorage.setItem('accessUserId', apiResponse.user.user_id)
          localStorage.setItem('user', JSON.stringify(apiResponse.user.data))
          localStorage.setItem('userDetail', apiResponse.user.userDetail)

          // please understand the whole process before changing this (implemented by Hasinur)
          const loginPanel = apiResponse.user.office_detail !== null ? 'admin' : 'external'
          localStorage.setItem('user_panel_type', loginPanel)
          // end changes

          let homePage = this.serviceUrl.externalPanelServiceUrl
          if (homePage === undefined || homePage === null || homePage.length < 10) {
            homePage = '/common/dashboard'
          }
          if (apiResponse.user.user_type === 0) {
            homePage = '/auth/role-select'
          }
          this.$router.push(homePage).catch(() => {})
        } else {
            this.errorAlert = true
            this.errorMsg = this.$t('authentication.loginError')
            this.$router.push('/auth/login').catch(() => {})
        }
      } catch (error) {
        if (error) {
          //
        }
        this.errorAlert = true
        this.errorMsg = this.$t('authentication.loginError')
        this.$router.push('/auth/login').catch(() => {})
      }
    },
    async logins () {
      try {
        this.loading = true
        this.user.username = this.user.email

        if (this.user.email.indexOf('@') === -1) {
          const res = await RestApi.getData(authServiceBaseUrl, usernameCheckApi, { username: this.user.email })
          if (res.success) {
            this.user.username = res.data
          } else {
            this.errorAlert = true
            this.errorMsg = this.$t('authentication.loginError')
            this.loading = false
            return
          }
        }

        const creds = Object.assign(
          {},
          this.user,
          { grant_type: 'password', client_id: process.env.VUE_APP_AUTH_CLIENT_ID, client_secret: process.env.VUE_APP_AUTH_CLIENT_SEC }
        )
        const result = await RestApi.postData(authServiceBaseUrl, '/v1/oauth/token', creds)

        if (!result.access_token) {
          this.errorAlert = true
          this.errorMsg = this.$t('authentication.loginError')
          this.loading = false
          return
        }

        localStorage.setItem('access_token', result.access_token)

        const apiResponse = await RestApi.getData(authServiceBaseUrl, userDataApi, null)
        if (apiResponse.success) {
          this.$store.dispatch('Auth/updateAuthUser', Object.assign(
            {},
            apiResponse.data,
            {
              username: apiResponse.username,
              user_id: apiResponse.user_id,
              user_type: apiResponse.user_type,
              is_org_admin: apiResponse.is_org_admin,
              office_detail: apiResponse.office_detail,
              last_panel: apiResponse.last_panel,
              panels: apiResponse.panels,
              userDetail: apiResponse.userDetail,
              dashboard_user: apiResponse.dashboard_user
            }))
          localStorage.setItem('accessUsername', apiResponse.username)
          localStorage.setItem('accessUserId', apiResponse.user_id)
          localStorage.setItem('user', JSON.stringify(apiResponse.data))
          localStorage.setItem('userDetail', apiResponse.userDetail)
          this.apiResponse = apiResponse
          let homePage = this.serviceUrl.externalPanelServiceUrl
          if (homePage === undefined || homePage === null || homePage.length < 10) {
            homePage = '/common/dashboard'
          }
          if (apiResponse.user_type === 0 && apiResponse.dashboard_user) {
            homePage = '/ministry/dashboard/grant'
          } else if (apiResponse.user_type === 0) {
            homePage = '/auth/role-select'
          }
          this.$router.push(homePage)
        } else {
            this.errorAlert = true
            this.errorMsg = this.$t('authentication.loginError')
            this.$router.push('/auth/login')
        }
      } catch (error) {
        if (error) {
          alert(error)
        }
        this.errorAlert = true
        this.errorMsg = this.$t('authentication.loginError')
        this.loading = false
      }
    },
    ...mapActions({
      langChangeState: 'Setting/setLangAction'
    })
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Hind+Siliguri:wght@600&display=swap');
  .login_wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    /* padding: 0 2rem; */
  }
  .login_wrapper .company-logo {
    margin-top: 50px;
    padding: 2px 15px;
    color: #fff;
    background: rgb(29 76 29 / 70%) !important;
    text-align: right;
    border-radius: 4px;
    box-shadow: 0px 1px 6px 1px rgb(24 51 21);
  }
  .login_wrapper .company-logo a:hover {
    text-decoration: none !important;
  }
  .card {
        background: rgb(29 76 29 / 70%) !important;
        /* border: none !important; */
        color: #fff !important;
        min-width: 22em !important;
        border: 1px solid rgb(0, 255, 255);
        z-index: 999999;
        box-shadow: 0px 1px 6px 1px rgb(24 51 21);
    }
  .card-body{
    padding: 20px;
  }
  .login-form {
    border: 1px #FFF !important;
  }
  .login-form-area {
    position: relative !important;
  }
  .loader {
    background: rgb(29 80 26 / 90%);
    width: 100% !important;
    height: 100% !important;
    z-index: 100;
  }
  .loader img {
    position: absolute !important;
    top: 50%;
    left: 50%;
    width: 85px;
    transform: translate(-50%, -50%);
    z-index: 9;
  }
  /* input#email[data-v-3f9ae065], input#password[data-v-3f9ae065] {
      border: 1px solid #c1c1c1;
      height: 32px;
      background: #ffffffc2 !important;
      border: none;
      border-radius: 0px 50px 50px 0px;
  } */
  a {
    color: #ffffff !important;
  }
  a:hover {
      color: #eee !important;
      text-decoration: underline !important;
  }
  .card-header{
    background-color: #c7cef8 !important; border-bottom: 0px!important;
  }
  .btn-custom{
    background-color: #596DE1;
    color: #fff;
  }
  input#email, input#password{
    border: 1px solid #c1c1c1;
  }
  .invalid-feedback{
    margin-left: 43px;
  }
  .form-control {
    background: #FFF !important;
    color: #000 !important;
    /* color: #ffffff !important; */
  }
  label {
    color: #ffffff;
  }
  [dir=ltr][mode=light] .is-invalid ~ .invalid-feedback, [dir=ltr][mode=light] .is-invalid ~ .invalid-tooltip, [dir=ltr][mode=light] .was-validated :invalid ~ .invalid-feedback, [dir=ltr][mode=light] .was-validated :invalid ~ .invalid-tooltip {
    font-weight: 500;
    font-size: 14px;
    color: #fb6363;
  }
</style>
